module.exports = __webpack_public_path__ + "img/checked-box-some.b1194602.svg";